import { render } from "./captcha.vue?vue&type=template&id=8c272c6c&scoped=true"
import script from "./captcha.vue?vue&type=script&lang=js"
export * from "./captcha.vue?vue&type=script&lang=js"

import "./captcha.vue?vue&type=style&index=0&id=8c272c6c&scoped=true&lang=css"

import exportComponent from "/vuebuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c272c6c"]])

export default __exports__